/* unplugin-vue-components disabled */import { render } from "./ToggleDark.vue?vue&type=template&id=466b2b5c&scoped=true"
import script from "./ToggleDark.vue?vue&type=script&lang=js"
export * from "./ToggleDark.vue?vue&type=script&lang=js"

import "./ToggleDark.vue?vue&type=style&index=0&id=466b2b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466b2b5c"]])

export default __exports__